export const parent = (
  orgPath: string,
  page: "login" | "signup",
  method: "email" | "phone",
  searchParams?: URLSearchParams
) => {
  const urlSearchParams = new URLSearchParams({
    page,
    method,
  });
  searchParams?.forEach((value, key) => {
    urlSearchParams.set(key, value);
  });
  return `/${orgPath}?${urlSearchParams.toString()}`;
};

export const admin = (orgPath: string) => {
  const searchParams = new URLSearchParams({
    page: "login",
  });
  return `/${orgPath}/admin?${searchParams.toString()}`;
};
